import Utils from "../../../../../shared/utils";

export const CHEVRON = Utils.buildNewsletterLink("icons/chevron.svg");
